import axios from "axios";
import AuthAxios from "api/Axios/authAxios";

// Onboard Employee registration
export const onboardEmployee = async (payload) => {
    const response = await AuthAxios.post(`/employee`, payload);
    return response.data;
}

export const updateEmployee = async (payload) => {
    const { employeeId, ...data } = payload;
    const response = await AuthAxios.put(`/employee`, data, {
        params: {
            employeeId
        }
    });
    return response.data;
}

export const getAllCredentials = async (payload) => {
    const response = await AuthAxios.get(`/employee/all`, { params: payload });
    return response.data;
}

export const getAllRoles = async () => {
    const response = await AuthAxios.get(`/employee/role`);
    return response.data;
}

export const createNewRole = async (payload) => {
    const response = await AuthAxios.post(`/employee/role`, payload);
    return response.data;
}

export const getTemplates = async () => {
    const response = await AuthAxios.get(`/employee/template`);
    return response.data;
}

export const getRoleTemplates = async (roleId) => {
    const response = await AuthAxios.get(`/employee/role/templates`, {
        params: { roleId }
    });
    return response.data;
}

const MSSQL_TABLES_API_URL = "https://dev-api.storymetrics.ai/story/v1/tables/mssql/";

export const getDataSourceList = async () => {
    const token = localStorage.getItem("authToken");
    const tenantId = localStorage.getItem("tenantId");
    const headers = {};
    if (token) headers["Authorization"] = `Bearer ${token}`;
    if (tenantId) headers["tenant-app-id"] = tenantId;
    const response = await axios.get(MSSQL_TABLES_API_URL, { headers });
    return response.data;
}